import app from 'flarum/common/app';

app.initializers.add('maisen20/update-ki-model', () => {
  console.log('[maisen20/update-ki-model] Hello, forum and admin!');
});
